import { render } from "./AccountActivation.vue?vue&type=template&id=8d1eb71c&scoped=true"
import script from "./AccountActivation.vue?vue&type=script&lang=js"
export * from "./AccountActivation.vue?vue&type=script&lang=js"

import "./AccountActivation.vue?vue&type=style&index=0&id=8d1eb71c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d1eb71c"]])

export default __exports__